import { cx } from "../../lib/index.js";
import { ClockIcon, TrashIcon } from "./icons.js";
export function createAutocompleteRecentSearchComponent(_ref) {
  var createElement = _ref.createElement;
  return function AutocompleteRecentSearch(_ref2) {
    var item = _ref2.item,
      children = _ref2.children,
      onSelect = _ref2.onSelect,
      onRemoveRecentSearch = _ref2.onRemoveRecentSearch,
      _ref2$classNames = _ref2.classNames,
      classNames = _ref2$classNames === void 0 ? {} : _ref2$classNames;
    return createElement("div", {
      onClick: onSelect,
      className: cx('ais-AutocompleteItemWrapper ais-AutocompleteRecentSearchWrapper', classNames.root)
    }, createElement("div", {
      className: cx('ais-AutocompleteItemContent', 'ais-AutocompleteRecentSearchItemContent', classNames.content)
    }, createElement("div", {
      className: cx('ais-AutocompleteItemIcon', 'ais-AutocompleteRecentSearchItemIcon', classNames.content)
    }, createElement(ClockIcon, {
      createElement: createElement
    })), createElement("div", {
      className: cx('ais-AutocompleteItemContentBody', 'ais-AutocompleteRecentSearchItemContentBody', classNames.content)
    }, children)), createElement("div", {
      className: cx('ais-AutocompleteItemActions', 'ais-AutocompleteRecentSearchItemActions', classNames.actions)
    }, createElement("button", {
      className: cx('ais-AutocompleteItemActionButton', 'ais-AutocompleteRecentSearchItemDeleteButton', classNames.deleteButton),
      title: "Remove ".concat(item.query, " from recent searches"),
      onClick: function onClick(evt) {
        evt.stopPropagation();
        onRemoveRecentSearch();
      }
    }, createElement(TrashIcon, {
      createElement: createElement
    }))));
  };
}